
/* injects from baggage-loader */
require('./vin.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('vin', {
    templateUrl: '/app/components/deal-sheet/vehicle/vin.component.html',
    bindings: {
        value: '<',
        modelNumber: '<'
    }
});
